<template>
  <div>
    <!--导航栏 start-->
    <van-nav-bar title="商户信息" left-text="返回" left-arrow fixed @click-left="onClickLeft" />
    <!--导航栏 end-->
    <!--内容 start-->
    <div class="content">
      <van-cell title="基本信息" is-link @click="basic_information" />
      <!--            <van-cell title="门店信息" is-link @click="store_information"/>-->
      <!-- <van-cell title="员工管理" is-link @click="staff_management"/>
            <van-cell title="我的客服" is-link @click="service_information"/> -->
      <van-cell title="修改密码" is-link value="修改" @click="change_password" />
      <van-cell title="解除微信绑定" is-link @click="sign_wechat" />
    </div>
    <!--内容 end-->
    <div style="margin: 16px;">
      <van-button round block type="info" native-type="submit" @click="sign_out">
        退出登录
      </van-button>
    </div>
  </div>
</template>

<script>
import { Dialog, Toast } from 'vant'

export default {
  name: 'AgentInfomation', // 商户信息
  methods: {
    // 左侧返回
    onClickLeft() {
      this.$router.push('/AgentHomepage')
    },
    // 基本信息
    basic_information() {
      // 跳转至基本信息
      this.$router.push('/AgentBasicinfomation')
    },
    // 门店信息
    // store_information() {
    //     // 跳转至门店信息
    //     this.$router.push("/StoreInformation");
    // },
    // 员工管理
    // staff_management() {
    //     // 跳转至员工管理
    //     this.$router.push("/StaffManagement");
    // },
    // 客服信息
    // service_information() {
    //     // 跳转至客服信息
    //     this.$router.push("/ServiceInformation");
    // },
    // 修改密码
    change_password() {
      this.$router.push('/AgentChangePassword')
    },
    // 退出登录
    sign_out() {
      Dialog.confirm({
        title: '温馨提示',
        message: '您确定要退出吗？'
      }).then(() => {
        this.Logout()
      })
        .catch(() => {
          // on cancel
        })
    },

    sign_wechat() {
      Dialog.confirm({
        title: '温馨提示',
        message: '您确定要解除绑定吗？'
      }).then(() => {
        this.Logwechat()
      })
        .catch(() => {
          // on cancel
        })
    },

    Logwechat() {
      var toast = Toast.loading({
        duration: 0,
        message: '正在解绑',
        forbidClick: true,
        loadingType: 'spinner'
      })
      this.$http.delete('/wechat/api.agent.index/unBindAccount', {
        params: {
          openid: window.localStorage.getItem('openid')
        }
      }).then(response => {
        // 跳转至登陆界面
        toast.clear()
        sessionStorage.clear()
        console.log('退出成功' + response.data)
        var toas = Toast.loading({
          duration: 0,
          message: '解绑成功',
          forbidClick: true,
          loadingType: 'spinner'
        })
        this.$router.push('/AgentImpower')
        setTimeout(function() {
          toas.clear()
        }, 1000)
      })
    },

    // 退出登录请求
    Logout() {
      var toast = Toast.loading({
        duration: 0,
        message: '正在退出',
        forbidClick: true,
        loadingType: 'spinner'
      })
      setTimeout(() => {
        // 跳转至登陆界面
        toast.clear()
        sessionStorage.clear()
        this.$router.push('/AgentImpower')
      }, 1000)
    }
  }
}
</script>

<style scoped lang="less">
/*标题整体*/
.topbar {
  background: #00aaee;
  color: #fff;
  padding: 13px 0;
  width: 100%;
  text-align: center;
}
.content {
  margin: 1.5rem 15px 15px 15px;
  border-radius: 10px;
  overflow: hidden;
}
::v-deep .van-cell {
  color: rgba(117, 117, 117, 1);
}
</style>
